export const CREDIT_REPORT_ACCOUNT_CATEGORIES = [
    'bankAccount',
    'creditCard',
    'utility',
    'mortgage',
    'personalLoan',
    'hirePurchase',
    'studentLoan',
    'rental',
    'other',
];
